export default "__VITE_ASSET__DFE$MY3O__"